jQuery(function($){
	$(window).scroll(function(){
		if(typeof(true_posts) !== "undefined" && true_posts !== null){
			var bottomOffset = 2000; // отступ от нижней границы сайта, до которого должен доскроллить пользователь, чтобы подгрузились новые посты
			var data = {
				'action': 'loadmore',
				'query': true_posts,
				'page' : current_page
			};

			if( $(document).scrollTop() > ($(document).height() - bottomOffset) && !$('body').hasClass('loading')){
				$.ajax({
					url:ajaxurl,
					data:data,
					type:'POST',
					beforeSend: function(xhr){
						$('body').addClass('loading');
					},
					success:function(data){
						if( data ) {
							$('.b-agenda > .b-agendalist__item').last().after(data);

							$('.b-agendalist__item').each(function(){
										if ($(this).index()>0 && $(this).index()%2>0) {
											var rightBlockTopMargin=$('.b-agendalist__item').eq( ($(this).index()-1) ).height()/2;
											$(this).css('margin-top',rightBlockTopMargin);
											}
										});

							$('.b-agendalist__item').each(function(){
										if ($(this).index()>0 && $(this).index()%2===0) {
											var leftBlockTopMargin=$('.b-agendalist__item').eq( ($(this).index()-1) ).height()/2;
											$(this).css('margin-top','-60px');
											}
										});

							$('body').removeClass('loading');
							current_page++;
						}
					}
				});
			}
		}
	});
});
